import React from 'react'
import Layout from '../components/Layout'
import Helmet from "react-helmet";

const NotFoundPage = () => (
  <Layout>
    <div className="container">
      <div id="main_container">
        <Helmet titleTemplate="%s">
          <title>404 Page Not Found</title>
        </Helmet>
        <section id="main_wide">
          <h2>Page Not Found</h2>
        </section>
      </div>
    </div>
  </Layout>
);

export default NotFoundPage
